/* Count rendered listings only; order-service products are excluded by Liquid. */
(() => {
  if (!document.body.matches('.el-page-collection,.el-page-search')) return;
  const main=document.querySelector('#MainContent');
  const update=()=>{
    const grid=main.querySelector('#product-grid');
    if(!grid)return;
    const count=grid.querySelectorAll('li.grid__item').length;
    const text=`${count} ${document.body.matches('.el-page-search') ? (count===1?'result':'results') : (count===1?'product':'products')}${main.querySelector('.pagination-wrapper')?' on this page':''}`;
    main.querySelectorAll('#ProductCount,#ProductCountDesktop,.mobile-facets__count,.template-search__header>p[role="status"]').forEach(el=>{if(el.textContent.trim()!==text)el.textContent=text;});
  };
  update();
  new MutationObserver(update).observe(main,{childList:true,subtree:true});
})();
